import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const ScrollButtonLeft = styled(Box)`
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  padding-right: ${(p) => p.theme.spacing(5)};
  /* padding-left: ${(p) => p.theme.spacing(2)}; */
  height: 100%;
  background: linear-gradient(90deg, #fff 39.9%, rgba(255, 255, 255, 0) 100%);
  border-radius: ${(p) => p.theme.spacing(1)};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 9;
`;

export const ScrollableArea = styled('div')`
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  white-space: nowrap;
  flex: 1;
  position: relative;
  width: 10vw;
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
  height: ${(p) => p.theme.spacing(4.75)};
`;

export const ScrollButton = styled(Box)`
  margin-left: 4px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding-left: ${(p) => p.theme.spacing(5)};
  padding-right: ${(p) => p.theme.spacing(0.5)};
  height: 100%;
  background: linear-gradient(270deg, #fff 69.48%, rgba(255, 255, 255, 0) 100%);
  border-radius: ${(p) => p.theme.spacing(1)};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
